import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AnimatedBackground } from './AnimatedBackground';
import { ArrowRightIcon, FileTextIcon, ChevronDownIcon } from 'lucide-react';
import { useReducedMotion } from '../hooks/useReducedMotion';
import { ease, duration } from '../motion/settings';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function Hero() {
  const prefersReducedMotion = useReducedMotion();
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden" data-id="element-48">
      <AnimatedBackground data-id="element-49" />
      <motion.div variants={containerVariants} initial="hidden" animate="visible" className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center" data-id="element-50">
        <motion.div variants={itemVariants} className="mb-8" data-id="element-51">
          <motion.img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1WHdFrSi1U2g2cCzqvimde/Minimalist_Black_Leaf_Logo_%281%29.png" alt="Pericles Partners" className="w-20 h-20 mx-auto mb-4 invert opacity-90" animate={prefersReducedMotion ? {} : {
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-52" />
        </motion.div>
        <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-bold mb-6 tracking-tight" style={{
        textShadow: '0 0 40px rgba(30, 58, 138, 0.3)'
      }} data-id="element-53">
          Where Weird Ideas Meet Real Money.
        </motion.h1>
        <motion.p variants={itemVariants} className="text-xl md:text-2xl text-slate mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-54">
          A student-run quant research lab exploring edges too small for big
          funds and too interesting to ignore.
        </motion.p>
        <motion.div variants={itemVariants} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-55">
          <motion.a href="#join" whileHover={prefersReducedMotion ? {} : {
          scale: 1.05,
          boxShadow: '0 0 30px rgba(30, 58, 138, 0.5)'
        }} whileTap={prefersReducedMotion ? {} : {
          scale: 0.95
        }} className="group px-8 py-4 bg-navy-700 text-white rounded-lg font-semibold text-lg transition-all duration-300 hover:bg-navy-600 flex items-center gap-2" data-id="element-56">
            Apply to Join
            <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-57" />
          </motion.a>
          <motion.a href="#how-different" whileHover={prefersReducedMotion ? {} : {
          scale: 1.05,
          borderColor: 'rgba(30, 58, 138, 0.8)'
        }} whileTap={prefersReducedMotion ? {} : {
          scale: 0.95
        }} className="group px-8 py-4 bg-transparent border-2 border-steel text-white rounded-lg font-semibold text-lg transition-all duration-300 hover:border-navy-700 hover:text-navy-500 flex items-center gap-2" data-id="element-58">
            Read the Thesis
            <FileTextIcon className="w-5 h-5" data-id="element-59" />
          </motion.a>
        </motion.div>
        {!prefersReducedMotion && <motion.button variants={itemVariants} onClick={scrollToContent} className="mt-20 mx-auto block" data-id="element-60">
            <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 2.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-61">
              <ChevronDownIcon className="w-8 h-8 text-navy-700" data-id="element-62" />
            </motion.div>
          </motion.button>}
      </motion.div>
    </section>;
}